import { render, staticRenderFns } from "./level-3-1.vue?vue&type=template&id=517ea6d9&"
import script from "./level-3-1.vue?vue&type=script&lang=js&"
export * from "./level-3-1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports